<template>
  <scoped>
    <VerticalNavigator
      :links="[{
        title: 'Create',
        routeName: 'create_deliverable'
      }]"
    >
      <Breadcrumb
        :links="[{
          title: 'RutSolve',
          routeName: 'index'
        }]"
        title="Deliverables"
      />
      <h1>
        Deliverables
      </h1>
      <div class="grid">
        <div class="list">
          <DeliverableSelector v-model:value="selectedDeliverable" />
        </div>
        <div
          v-if="selectedDeliverable"
          class="summary"
        >
          <DeliverableSummary
            :key="selectedDeliverable.id"
            :deliverableID="selectedDeliverable.id"
          />
          <Button
            title="Edit"
            :image="require('@/images/edit_icon.png')"
            @click="deliverableRedirect()"
          />
        </div>
      </div>
    </VerticalNavigator>
  </scoped>
</template>

<script setup lang="ts">
  import DeliverableSelector from "@/components/selectors/deliverable.vue"
  import Breadcrumb from "@/components/breadcrumb.vue"
  import VerticalNavigator from "@/layouts/vertical_navigator.vue"
  import {ref} from "vue"
  import Button from "@/components/button.vue"
  import DeliverableSummary from "@/components/summaries/deliverable.vue"
  import router from "@/router"
  import {Deliverable} from "@/endpoints/rutsolve/gql/generated/graphql"
  
  const selectedDeliverable = ref<Deliverable>(null)
  
  function deliverableRedirect() {
    router.push({
      name: "edit_deliverable",
      params: {
        deliverableID: selectedDeliverable.value.id
      }
    })
  }
</script>

<style scoped>
  .grid {
    display: grid;
    grid-template-areas: "list summary";
    grid-template-columns: auto 1fr;
  
    .list {
      grid-area: list;
      margin: 0 1em 1em 0;
    }
  
    .summary {
      grid-area: summary;
    }
  }
</style>
